export enum StavUzivatele {
	POVOLEN = 'POVOLEN',
	NEOVEREN = 'NEOVEREN',
	ZRUSEN = 'ZRUSEN',
	IMPORTOVAN = 'IMPORTOVAN'
}
